// extracted by mini-css-extract-plugin
module.exports = {"continue-my-review":"components-ContentHeader-ContinueMyReview-ContinueMyReview__continue-my-review--2BgGo"};